'use client'

import React, { useState } from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import StarRating from './starsComponent';
import { PiUserCircleThin } from "react-icons/pi";
import { useSession } from "next-auth/react";
import EditeReview from '../user-dashboard/editeReview';
import { useTranslations } from 'next-intl';
import useFetchImagesReviews from '../admin-dashboard/fetchImageRviews';

import DeleteReview from '../user-dashboard/deletReviews';


import Image from "next/image";
import { Gallery, Item } from "react-photoswipe-gallery";
const DoubleAccordion = ({content, reviews}:{content:any, reviews: any}) => {
  // State for first accordion
  const [firstAccordionActive, setFirstAccordionActive] = useState<number | null>(null);
  // State for second accordion
  const [secondAccordionActive, setSecondAccordionActive] = useState<number | null>(null);
  const { data: session, status } = useSession();
  const t = useTranslations('Shop-id');
  const te = useTranslations('orders');
  const averageRating = (reviews.reduce((sum:any, review:any) => sum + +review.rating, 0)) / reviews.length;

 const lengtReviews = reviews.length;
const { ImagesReviews: imagesReviews } = useFetchImagesReviews();

  const handleFirstAccordionClick = (index: number) => {
    setFirstAccordionActive(firstAccordionActive === index ? null : index);
  };

  const handleSecondAccordionClick = (index: number) => {
    setSecondAccordionActive(secondAccordionActive === index ? null : index);
  };

  const getFlagEmoji = (countryCode:any) => {
    return countryCode
      .toUpperCase()
      .replace(/./g, (char:any) => String.fromCodePoint(127397 + char.charCodeAt()));
  };


  const roundFirstDecimalDigit = (num:number) => {
    const intPart = Math.floor(num);
    const decimal = num - intPart;
  
    // Shift decimal left to isolate the first two digits
    const shifted = decimal * 10;
    const roundedFirst = Math.round(shifted);
  
    // Recombine with integer part
    return intPart + roundedFirst / 10;
  }


  return (
    <div className="space-y-8">
      {/* First Accordion */}
      <div className="w-full space-y-4">
   
        <hr className="border-spacing-1" />
        
        <div className="mb-2 space-y-4 cursor-pointer">
          <div onClick={() => handleFirstAccordionClick(0)} className='font-semibold uppercase text-lg flex items-center justify-between'>
           {t('Reviews')}
          {averageRating? 
           <div className='flex gap-1'>
            <p>{roundFirstDecimalDigit(averageRating)}</p>
             <StarRating rating={averageRating} />      
             <p className='font-light'>{"("}{lengtReviews}{")"}</p>   
           </div>
           :""}
            {firstAccordionActive === 0 ? 
              <MdOutlineKeyboardArrowDown size={32} className='rotate-180'/> : 
              <MdOutlineKeyboardArrowDown size={32}/>
            }
             
          </div>
          <hr className="border-spacing-1" />
          {firstAccordionActive === 0 && (
            <div className="py-2 space-y-4">
               
{reviews.map((item: any, index: any) => {
  const reviewImages = imagesReviews.filter(
    (post) => post.ProductReview === item.id
  );

  return (
    <div key={index} className='space-y-1'>
      
      {/* HEADER */}
      <div className='flex justify-between'>
        <div className='flex gap-2 items-center text-sm'>
          <PiUserCircleThin size={24} className='text-gray-600'/>
          <p className='capitalize'>{item.name.slice(0,3)}***</p> 
          <p className='text-gray-500'>{te('in')}</p>
          <span>{getFlagEmoji(item.country.slice(0,2))}</span>
          <p className='text-gray-500'>{te('on')}</p>
          <p className='text-gray-500'>{item.created_at}</p>
        </div>

        {session?.user.id == item.user && (
          <DeleteReview reviewid={item.id} />
          
        )}
      </div>

      {/* META */}
      <div className='flex gap-1 text-sm'>
        {item.color && (
          <p className='text-gray-500'>
            {te('purchased')} {t('Color')} {item.color}
          </p>
        )}
        {item.size && (
          <p className='text-gray-500'>
            {t('Size')} {item.size}
          </p>
        )}
      </div>

      <StarRating rating={item.rating} />         
      <p className='text-gray-800'>{item.comment}</p>

      {/* ✅ IMAGES */}
      {reviewImages.length > 0 && (
        <div className='flex gap-1 flex-wrap'>
          <Gallery>
            {reviewImages.map((img: any, i: number) => (
              <Item
                key={i}
                original={`${process.env.NEXT_PUBLIC_IMAGE}/${img.image}`}
                width="2000"
                height="2000"
              >
                {({ ref, open }) => (
                  <Image
                    ref={ref}
                    onClick={open}
                    height={200}
                    width={200}
                    src={`${process.env.NEXT_PUBLIC_IMAGE}/${img.image}`}
                    alt="review"
                    className="cursor-pointer rounded"
                  />
                )}
              </Item>

            ))}
          </Gallery>

        
        </div>
      )}

    </div>
  );
})}
     
            </div>
          )}
        </div>

        <div className="mb-2 space-y-4 cursor-pointer">
          <div onClick={() => handleFirstAccordionClick(1)} className='font-semibold uppercase text-lg flex items-center justify-between'>
           {t('Description')}
            {firstAccordionActive === 1 ? 
              <MdOutlineKeyboardArrowDown size={32} className='rotate-180'/> : 
              <MdOutlineKeyboardArrowDown size={32}/>
            }
          </div>
          <hr className="border-spacing-1" />
          {firstAccordionActive === 1 && (
       
           <div className="py-2 text-gray-700 post-content">
             {content}
            </div>
           
          )}
        </div>
      </div>

     
     
    </div>
  );
};

export default DoubleAccordion;